/**
 * VENDOR MODULES
 */
import React from 'react';
import i18n  from "i18n";

/***/
function ForecastTooltip() {
    const [active, setActive] = React.useState('tab-straight-forecast');

    return (
        <div className="straight-reverse-forecast outcome-tooltip animate-mls-5">
            <div
              className={`
                tab-straight-forecast
                outcome-tooltip-item
                ${active == 'tab-straight-forecast' && 'active'}
              `}
              onClick={() => setActive('tab-straight-forecast')}
            >
              <span>{i18n.t(`IN_ORDER`)}</span>
            </div>
            <div
              className={`
                tab-reverse-forecast
                outcome-tooltip-item
                ${active == 'tab-reverse-forecast' && 'active'}
              `}
              onClick={() => setActive('tab-reverse-forecast')}
            >
              <span>{i18n.t(`NOT_IN_ORDER`)}</span>
            </div>
        </div>
    );
}

export default ForecastTooltip;

